import { useLayoutEffect } from 'react';
import { useSidebar } from '../contexts/SidebarContext';

/**
 * Call this in any page that should have no sidebar.
 * Clears items synchronously before paint so the sidebar never flashes.
 */
export const useNoSidebar = () => {
  const { setItems, setFooterItems, setActiveItem } = useSidebar();

  useLayoutEffect(() => {
    setItems([]);
    setFooterItems([]);
    setActiveItem(null);
  }, [setItems, setFooterItems, setActiveItem]);
};
